import { useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";

export const EditorHtml = ({ valorinicial, nombre, cambiohtml }) => {
	const [html, sethtml] = useState(valorinicial);
	const editorRef = useRef(null);
	useEffect(() => {
		sethtml(valorinicial);
		// console.log(valorinicial);
	}, [valorinicial]);
	return (
		<Editor
			apiKey="o5q04bnufvv9rxsfnypiqp9ayqawi777xq9lcvnuofy6ypee"
			onInit={(evt, editor) => (editorRef.current = editor)}
			initialValue={html}
			onBlur={() => {
				cambiohtml(editorRef.current.getContent(), nombre);
			}}
			init={{
				max_with: 600,
				height: 300,
				menubar: true,
				plugins: [
					"code",
					"link",
					"image",
					"lists",
					"table",
					"charmap",
					"preview",
					"searchreplace",
					"emoticons",
					"help",
				],
				// Organizar toolbar en múltiples líneas para que todo sea visible
				toolbar_mode: "wrap",
				toolbar:
					"undo redo | blocks | " +
					"bold italic underline strikethrough | forecolor backcolor | " +
					"alignleft aligncenter alignright alignjustify | " +
					"bullist numlist outdent indent | " +
					"link image table | charmap emoticons | " +
					"removeformat | code preview help",

				// Configuración para habilitar la inserción de imágenes
				automatic_uploads: true,
				file_picker_types: "image",
				images_upload_handler: (blobInfo, progress) =>
					new Promise((resolve, reject) => {
						// Convertir imagen a base64
						const reader = new FileReader();
						reader.onloadend = () => {
							resolve(reader.result);
						};
						reader.onerror = () => {
							reject("Error al cargar la imagen");
						};
						reader.readAsDataURL(blobInfo.blob());
					}),

				content_style:
					"body { font-family:Helvetica,Arial,sans-serif; font-size:14px ;  }",
				menu: {
					file: {
						title: "File",
						items: "restoredraft | preview ",
					},
					edit: {
						title: "Edit",
						items: "undo redo | cut copy paste | selectall | searchreplace",
					},

					insert: {
						title: "Insert",
						items:
							"image |  link |  media | template|  codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime",
					},
					format: {
						title: "Format",
						items:
							"bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat",
					},
					tools: {
						title: "Tools",
						items: "spellchecker spellcheckerlanguage | code wordcount",
					},
					table: {
						title: "Table",
						items: "inserttable | cell row column | tableprops deletetable",
					},
					help: { title: "Help", items: "help" },
				},
			}}
		/>
	);
};
